import { render } from "./AdminFinancialDashboardView.vue?vue&type=template&id=37ca67bc&scoped=true"
import script from "./AdminFinancialDashboardView.vue?vue&type=script&lang=js"
export * from "./AdminFinancialDashboardView.vue?vue&type=script&lang=js"

import "./AdminFinancialDashboardView.vue?vue&type=style&index=0&id=37ca67bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ca67bc"]])

export default __exports__